import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ProcessingDialogData } from './types';

@Component({
  selector: 'mimecast-ui-processing-dialog',
  templateUrl: './processing-dialog.component.html',
  styleUrls: ['./processing-dialog.component.scss'],
  standalone: false,
})
export class ProcessingDialogComponent {
  @HostBinding('attr.data-test') dataTest = 'processing-dialog';

  protected defaultContent = $localize`We are processing your request. You will be redirected once this is complete.`;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProcessingDialogData,
    dialogRef: MatDialogRef<ProcessingDialogComponent>
  ) {
    dialogRef.disableClose = true;
  }
}
